import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';
import { ReactElement, memo } from 'react';

import * as BooleanButtonAffixStyles from './BooleanButtonAffix.styles';

export interface BooleanButtonAffixProps {
  children?: ReactElement | string;
  selected?: boolean;
}

function BooleanButtonAffix({ children, selected }: BooleanButtonAffixProps) {
  const { classes } = BooleanButtonAffixStyles.useWrapper();

  if (isNil(children)) return null;

  if (isString(children)) {
    return (
      <Box>
        <ListItemText
          primaryTypographyProps={{
            color: selected ? 'inherit' : 'textSecondary',
          }}
          primary={children}
          classes={{ primary: classes.affixText }}
          className={classes.noMargin}
        />
      </Box>
    );
  }

  return children;
}

export default memo(BooleanButtonAffix);
